import AppConstants from '../constants/appConstants';

export const LoginUser = (userId, email, name, phone) => {
  if (window.OneSignalDeferred) return;

  window.OneSignalDeferred = window.OneSignalDeferred || [];

  const script = document.createElement('script');
  script.src = AppConstants.OneSignalSDK;
  script.defer = true;
  document.head.appendChild(script);

  window.OneSignalDeferred.push(async OneSignal => {
    await OneSignal.init({
      appId: AppConstants.OneSignalAppID,
      notifyButton: { enable: true },
      allowLocalhostAsSecureOrigin: true,
    });

    if (userId) {
      await OneSignal.login(userId);
    }

    if (email) {
      await OneSignal.User.addEmail(email);
    }

    if (name) {
      const [firstName, ...lastName] = name.trim().split(' ');
      await OneSignal.User.addAlias('first_name', firstName);
      await OneSignal.User.addAlias('last_name', lastName.join(' '));
    }

    if (phone) {
      await OneSignal.User.addSms(phone);
    }
  });
};

export const logoutUser = () => {
  if (!window.OneSignalDeferred) return;

  window.OneSignalDeferred.push(async OneSignal => {
    await OneSignal.logout();
  });
};
